import { PluginFunc } from 'dayjs';

export const toServerFilterDate: PluginFunc = (option, dayjsClass, dayjsFactory) => {
  (dayjsClass as any).prototype.toServerFilterDate = function () {
    return this.format('YYYY-MM-DD');
  };
};
